module.exports = require("lodash.memoize");


//////////////////
// WEBPACK FOOTER
// external "lodash.memoize"
// module id = 4
// module chunks = 0